module.exports = __webpack_public_path__ + "img/no_toilet_paper.5c6a48b5.svg";